import { lazy, Suspense, useEffect, useRef, useState } from 'react';

const HomeProductRows = lazy(() => import('./HomeProductRows'));

function CardPlaceholders({ count }) {
  return Array.from({ length: count }, (_, index) => (
    <div key={index} aria-hidden="true" className="h-[420px] w-[290px] shrink-0 animate-pulse rounded-[20px] border border-slate-200 bg-slate-100" />
  ));
}

export default function HomeProductRowsBoundary({ products, variant = 'merch', loading = false }) {
  const [visible, setVisible] = useState(() => typeof IntersectionObserver === 'undefined');
  const ref = useRef(null);

  useEffect(() => {
    if (visible) return undefined;
    const element = ref.current;
    if (!element) return undefined;

    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setVisible(true);
        observer.disconnect();
      }
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [visible]);

  return (
    <div ref={ref} className="hide-scrollbar flex min-h-[420px] gap-[15px] overflow-x-auto pb-4">
      {loading || !visible ? (
        <CardPlaceholders count={variant === 'merch' ? 5 : Math.min(products.length, 4)} />
      ) : (
        <Suspense fallback={<CardPlaceholders count={variant === 'merch' ? 5 : Math.min(products.length, 4)} />}>
          <HomeProductRows products={products} variant={variant} />
        </Suspense>
      )}
    </div>
  );
}
